<template>
  <div class="row align-center">
    <div class="small-12 medium-9 large-9 columns content">
      <div class="row testemunhos_page">
        <div class="small-12 medium-12 large-4 columns">
          <h1>{{ $translate("UMA_LANG_TESTEMUNHOS_QUESTIONTESTEMUNHOS") }}</h1>
          <p>{{ $translate("UMA_LANG_TESTEMUNHOS_MSGTESTEMUNHO") }}</p>
        </div>
        <div class="small-12 medium-12 large-8 columns">
          <TestemunhoRow
              v-for="item in listItems"
              class="testemunhoItem"
              :class="item.colorclass"
              @click="goToTestemunhoDetail(item)"
              :nome="item.nome"
              :depoimento="item.depoimento"
              :curso="item.curso"
              :imagem="item.imagem"
              :key="item.nome" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import TestemunhoRow from '@/components/TestemunhoRow.vue';
import constants from "../constants.js";

export default {
  name: "testemunhosContainer",
  components: {
    TestemunhoRow
  },
  data() {
    return {
      listItems: [ ],
      color:""
    }
  },
  inject:["secundaryColors"],
  created(){
    this.color = this.secundaryColors[this.$store.state.color];
    const url = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}/testemunhos?idioma=${this.$store.state.language}`;
    fetch(url)
        .then(response => response.json())
        .then(data => {
          this.listItems = data.map(el => {
            return {
              id: el.ID,
              nome: el.Nome,
              depoimento: this.truncate(el.Depoimento,constants.maxChars," (...)"),
              imagem: el.Imagem,
              curso: el.Curso.post_title,
              url: el.Url,
              colorclass: el.Faculdade.name
            }
          })
        })
        .catch(error => console.log(error));
  },
  updated() {
    this.color = this.secundaryColors[this.$store.state.color];
  },
  methods:{
    truncate(str, max, suffix){
      return str.length < max ?
          str :
          `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`
    },
    goToTestemunhoDetail(testemunho){
      window.location = testemunho.url
    },
  }
}
</script>

<style scoped lang="scss">
@import "../global.scss";

.testemunhoItem:hover{
  cursor: pointer;
}

.testemunhos_page h1 {
    font-family: "Montserrat Semibold";
    font-size: 26px;
    color: #454648;
    line-height: 32px;
}

.testemunhos_page p {
  font-family: Montserrat Light;;
  font-size: 15px;
  color: #454648;
  padding-bottom: 10px;
  padding-top: 15px;
}

.testemunhos_page .columns:first-of-type {
  padding-right: 40px;
}

.testemunhos_page {
  margin-right: 0px;
  margin-left: 0px;
}



/*Responsive - ipad*/
@media (max-width: 1025px) {
  .testemunhos_page .columns:first-of-type {
    text-align: center;
}
  .testemunhos_page h1 {
    font-size: 22px;
  }

  .testemunhos_page p {
    padding-top: 0px;
    font-size: 14px;
  }

}

/*Responsive - iphone*/
@media (max-width: 767px) {

  .testemunhos_page h1 {
    font-size: 16px;
  }

  .testemunhos_page .columns:first-of-type {
    padding-right: 15px;
  }

  .testemunhos_page p {
    padding-bottom: 0px;
    font-size: 13px;
  }

  .testemunho_box .columns {
     padding-left: 30px;
  }

  .content {
    padding-bottom: 30px;
  }
}

.testemunhoItem.artes-e-humanidades {
  color: $artesHumanidades;
}
.testemunhoItem.ciencias-exatas-e-da-engenharia {
  color: $cee;
}
.testemunhoItem.ciencias-sociais {
  color: $cs;
}
.testemunhoItem.ciencias-da-vida {
  color: $cv;
}
.testemunhoItem.escola-superior-de-saude {
  color: $ess;
}
.testemunhoItem.escola-superior-de-tecnologia-e-gestao {
  color: $estg;
}

</style>